import { formatAsBRLWithSignal } from './number';

import OFFER from 'constants/offer';
import SOCIAL_MEDIA from 'constants/socialMedia';

export const formatOfferCouponShareText = ({
  offerTitle,
  offerPrice,
  offerPriceType,
}) => {
  let formattedPrice = '';

  switch (offerPriceType) {
    case OFFER.PRICE_TYPES.FREE:
      formattedPrice = `de graça`;
      break;
    case OFFER.PRICE_TYPES.STARTING_AT:
      formattedPrice = `a partir de ${formatAsBRLWithSignal(offerPrice)}`;
      break;
    case OFFER.PRICE_TYPES.COUPON:
      formattedPrice = `Cupom`;
      break;
    default:
      formattedPrice = `por ${formatAsBRLWithSignal(offerPrice)}`;
      break;
  }

  return `${offerTitle} - ${formattedPrice} no Promobit!`;
};

export const formatLinkWithUtms = ({
  redirectUrl,
  utmMedium,
  utmSource = 'promobit',
  utmCampaign,
}) =>
  `${redirectUrl}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${encodeURIComponent(
    utmCampaign
  )}`;

export const getSocialMediaShareUrl = (socialMedia, text) => {
  const socialMediaURL = SOCIAL_MEDIA[socialMedia.toUpperCase()].SHARE_URL;
  const url = encodeURIComponent(
    `${window.location.href}?${SOCIAL_MEDIA.SHARE_UTMS}`
  );
  const isEmail = socialMedia === SOCIAL_MEDIA.EMAIL.TITLE;
  const isWhatsapp = socialMedia === SOCIAL_MEDIA.WHATSAPP.TITLE;

  if (isEmail) {
    return `${socialMediaURL}${url}%20&text=${text}`;
  }

  if (isWhatsapp) {
    return `${socialMediaURL}?text=${text}%20${url}`;
  }

  return `${socialMediaURL}${url}&text=${text}`;
};

const toFormattedEmailShareUrl = ({ socialMediaURL, urlWithUtms, shareText }) =>
  `${socialMediaURL}${urlWithUtms}%20&text=${shareText}`;

const toFormattedGenericShareUrl = ({
  socialMediaURL,
  urlWithUtms,
  shareText,
}) => `${socialMediaURL}${urlWithUtms}&text=${shareText}`;

const toFormattedWhatsappShareUrl = ({ shareText, urlWithUtms }) => {
  const socialMediaURL = SOCIAL_MEDIA.WHATSAPP.SHARE_URL;

  return `${socialMediaURL}?text=${shareText}%20${urlWithUtms}`;
};

// TODO unify with shareOfferTo
// For future references see: https://github.com/bradvin/social-share-urls
export const shareCouponTo = ({
  couponTitle,
  offerPrice,
  offerPriceType,
  socialMedia,
  hasText = true,
}) => {
  const socialMediaURL = SOCIAL_MEDIA[socialMedia.toUpperCase()].SHARE_URL;
  const isEmail = socialMedia === SOCIAL_MEDIA.EMAIL.TITLE;
  const isWhatsapp = socialMedia === SOCIAL_MEDIA.WHATSAPP.TITLE;
  const url = encodeURIComponent(
    `${window.location.href}?${SOCIAL_MEDIA.SHARE_UTMS}`
  );
  let text = '';

  if (hasText) {
    const shareText = encodeURIComponent(
      formatOfferCouponShareText({ couponTitle, offerPrice, offerPriceType })
    );

    if (isEmail) {
      text = `${encodeURIComponent(
        'Encontrei essa oferta e acho que você vai gostar!'
      )}%0a%0a${shareText}`;

      window.open(`${socialMediaURL}${url}%20&text=${text}`);
    } else if (isWhatsapp) {
      window.open(`${socialMediaURL}?text=${shareText}%20${url}`);
    } else {
      window.open(`${socialMediaURL}${url}&text=${shareText}`);
    }
  }
};

// TODO unify with shareCouponTo
// For future references see: https://github.com/bradvin/social-share-urls
export const shareOfferTo = ({
  offerTitle,
  offerPrice,
  offerPriceType,
  socialMedia,
  hasText = true,
}) => {
  const socialMediaURL = SOCIAL_MEDIA[socialMedia.toUpperCase()].SHARE_URL;
  const isEmail = socialMedia === SOCIAL_MEDIA.EMAIL.TITLE;
  const isWhatsapp = socialMedia === SOCIAL_MEDIA.WHATSAPP.TITLE;
  const url = new URL(window.location);
  const urlWithUtms = encodeURIComponent(
    `${url.host}${url.pathname}?${SOCIAL_MEDIA.SHARE_UTMS}`
  );

  if (hasText) {
    let socialMediaUrlWithUtms = '';

    const shareText = encodeURIComponent(
      formatOfferCouponShareText({ offerTitle, offerPrice, offerPriceType })
    );

    if (isEmail) {
      const text = `${encodeURIComponent(
        'Encontrei essa oferta e acho que você vai gostar!'
      )}%0a%0a${shareText}`;

      socialMediaUrlWithUtms = toFormattedEmailShareUrl({
        shareText: text,
        socialMediaURL,
        urlWithUtms,
      });
    } else if (isWhatsapp) {
      socialMediaUrlWithUtms = toFormattedWhatsappShareUrl({
        shareText,
        urlWithUtms,
      });
    } else {
      socialMediaUrlWithUtms = toFormattedGenericShareUrl({
        shareText,
        socialMediaURL,
        urlWithUtms,
      });
    }

    window.open(socialMediaUrlWithUtms);
  }
};

export const shareTo = (socialMedia, text) => {
  const shareText = encodeURIComponent(text);

  window.open(getSocialMediaShareUrl(socialMedia, shareText));
};
